import { getAuth, sendPasswordResetEmail } from "firebase/auth";
import Form from "react-bootstrap/Form";
import { useState } from "react";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import { FirebaseError } from "firebase/app";
import firebaseErrors from "../../modules/firebaseErrors";

const auth = getAuth();

interface PasswordResetProps {
	changeMode: () => void;
}

export default function PasswordReset(props: PasswordResetProps) {
	const [resetting, setResetting] = useState(false);
	const [email, setEmail] = useState("");

	const [error, setError] = useState<string>();
	const [success, setSuccess] = useState(false);

	return (
		<div>
			<FloatingLabel label="Email-Adresse" className="mb-2">
				<Form.Control
					type="email"
					placeholder="Email-Adresse"
					value={email}
					onChange={(e) => setEmail(e.target.value)}
				/>
			</FloatingLabel>

			{error && <div className="mb-2 text-danger">{error}</div>}

			{success && (
				<div className="mb-2 text-success">
					Ein Link zum zurücksetzen des Passworts wurde an die Email-Adresse gesendet.
				</div>
			)}

			<div className="mb-2">
				<Button
					className="me-2"
					variant="success"
					disabled={resetting}
					onClick={async () => {
						setResetting(true);
						setSuccess(false);
						setError(undefined);

						try {
							await sendPasswordResetEmail(auth, email);
							setResetting(false);
							setSuccess(true);
						} catch (error) {
							if (error instanceof FirebaseError) {
								setResetting(false);

								const message = firebaseErrors[error.code] ?? error.message;

								setError(message);
								return;
							}

							throw error;
						}
					}}>
					{resetting && <Spinner className="me-1" animation="border" size="sm" />}
					Passwort zurücksetzen
				</Button>

				<Button variant="outline-primary" onClick={() => props.changeMode()}>
					Anmelden
				</Button>
			</div>
		</div>
	);
}
